import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper.jsx";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader.jsx";
import { useLocation } from "react-router";
import { LITE_TRADE_POSITION_SIDE } from "../../../../modules/LiteTrade/liteTradeConstants.js";
import MobilePositionCreate from "../../MobilePosition/MobilePositionCreate/MobilePositionCreate.jsx";
import { memo } from "react";
import { MobileSliderPagesContentStyled } from "../components/styled/MobileSliderPagesStyled.js";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import MobileOrderHeader from "../../MobilePosition/MobilePositionHeader/MobilePositionHeader";

function SlideMobilePositionCreate() {
    const location = useLocation();
    const {getLangPath} = useLangContext();

    const searchParams = new URLSearchParams(location.search);
    const symbol = searchParams.get('symbol');
    const side = searchParams.get('side')?.toLowerCase() === 'sell' ? LITE_TRADE_POSITION_SIDE.SELL : LITE_TRADE_POSITION_SIDE.BUY;

    return <MobileSliderPagesWrapper backgroundColor="var(--color-base)">
        <MobileSliderPagesHeader goBack>
            <MobileOrderHeader symbol={symbol}>
                {getLangPath('lite_version.order.title')}
            </MobileOrderHeader>
        </MobileSliderPagesHeader>

        <MobileSliderPagesContentStyled>
            <MobilePositionCreate symbol={symbol} side={side}/>
        </MobileSliderPagesContentStyled>

    </MobileSliderPagesWrapper>
}

export default memo(SlideMobilePositionCreate);
